import { cn } from '../lib/cn';

/**
 * A single shimmering placeholder block (moving-highlight sweep — see `.skeleton`
 * in styles.css). Size/shape it with className, e.g.
 *   <Skeleton className="h-4 w-40 rounded" />
 * Compose several to mock a row or card while data loads, so lists don't flash an
 * empty "(0)" state before the query resolves. Decorative → hidden from a11y tree.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('skeleton', className)} aria-hidden="true" />;
}
